/* eslint-disable no-undef */
let fullParent = function () {

    let parent = '.js-fullparent';
    $(parent).css('height', $(window).height()-55);
    $(parent).css('width', $(parent).parent().width());
    $(window).resize(function () {
        $(parent).css('height', $(window).height()-55);
        $(parent).css('width', $(parent).parent().width());
    });

    $('#canvas').css('height', $('#topbar').height() - 105);

};

export default fullParent;
